const getRandomString = (): string => {
    return (Math.random() * Math.pow(10, 17)).toString(16)
}

export module Random {
    export function id(): string {
        return `${getRandomString()}-${getRandomString()}`
    }
}